import { gsap, ScrollTrigger } from 'gsap/all';
import SplitText from "../__vendor/SplitText.min.js";


gsap.registerPlugin(ScrollTrigger);

const sectionContact = () => {
    const contactSectionTl = gsap.timeline({
        paused: true
    });

    const text = new SplitText(".contact h3, .contact .btn span", { type: "chars" });

    gsap.set(".contact h3 > div, .contact .btn span > div ", {
        opacity: 0,
        y: 15
    });
    
    gsap.set(" .contact .btn  ", {
        opacity: 0,
        y: 15
    });

    contactSectionTl.set('.contact', {
        className: "+=section contact active",
    }, 0.15).to('.contact .btn',{
        y:0,
        opacity:1
    }, 1).to(text.chars, {
        autoAlpha: 1,
        y: 0,
        stagger: 0.025,
    }, 1)

    ScrollTrigger.create({
        scroller:'[data-scroll-container]',
        trigger: '.contact',
        start: 'top bottom-=200',
        end: 'bottom top',
        animation: contactSectionTl,
        toggleActions: 'play none none none',
    });
};

export default sectionContact;